const messages = {
  fr: {
    infos: {
      retrait: {
        titre: "Retrait en magasin",
        fraisPrepa: "Frais de préparation : ",
        fraisRetrait: "Retrait magasin : "
      },
      livraison: {
        titre: "Livraison à domicile",
        fraisPrepa: "Frais de préparation : ",
        fraisLivraison: "Frais de livraison : ",
        freeDeliveryFrom: "Livraison gratuite à partir de : ", 
        minimumLivraison: "Minimum de commande : "
      }
    },
    horaires: {
      titre: {
        horaires: "Horaires disponibles",
        livraison: "pour la livraison à domicile",
        retrait: "pour le retrait en magasin"
      }
    },
    ie: {
      title: "Ce site ne fonctionne pas avec le navigateur Internet Explorer",
      description: "Veuillez changer de navigateur pour pouvoir passer commande",
      descriptionModal: "Votre navigateur Internet Explorer est obsolète et n'est pas compatible avec le fonctionnement de nos boutiques en ligne. Pour passer votre commande, nous vous conseillons d'utiliser un des navigateurs ci-dessous :"
    },
    bandeau: {
      changerStation: "Changer de station",
      dateLivraison: "Date de livraison",
      changer: "Changer"
    },
    calendrier: {
      click: {
        order: "Votre commande",
        for: "pour le ",
        sentence: "Choisissez l’heure de réception de votre commande à cette date"
      },
      livraison: {
        phrase: "Votre magasin livre sur la station",
        periodeGratuite: {
          intro: "Livraison gratuite en commandant dans la periode du ",
          mid: " au "
        }
      },
      bouton: {
        txt: "Ma commande pour aujourdhui",
        dernierhoraire: {
          retrait: "Heure limite de commande"
        }
      },
      choixJour: "Choix du jour de livraison ou de retrait en magasin",
      validerBouton: "Valider",
      recap: {
        commande: {
          first: "Votre commande",
          retrait: "à retirer en magasin",
          livraison: "livrée à domicile",
          second: "pour le",
          third: "à",
          submit: "Valider et commencer mes courses"
        }
      }
    },
    alert: {
      headerConfirm: 'Quitter le magasin',
      quitPresta: 'Êtes-vous sur de vouloir changer de magasin ? En effectuant cette action, votre panier sera vidé.',
      accept: 'OK',
      cancel: 'Annuler'
    },
    message: {
      "stop commande": "Le service est indisponible pour cette journée.",
      "stop livraison": "Le service est indisponible pour cette journée.",
      "max commande": "En raison d’un grand nombre de commandes, le service est indisponible pour cette journée.",
      "max livraison": "En raison d’un grand nombre de livraisons, le service est indisponible pour cette journée.",
      "hors delai livraison": "Le délai ne permet pas la livraison de votre commande à cette date",
      "hors delai retrait": "Le délai ne permet pas la préparation de votre commande pour cette date",
      "hors delai": "Hors délai",
      "hors saison": "Hors saison"
    }
  },
  en: {
    infos: {
      retrait: {
        titre: "In-store pick-up",
        fraisPrepa: "Preparation fees : ",
        fraisRetrait: "In-store pick-up fees : "
      },
      livraison: {
        titre: "Home delivery",
        fraisPrepa: "Preparation fees : ",
        fraisLivraison: "Delivery fees : ",
        freeDeliveryFrom: "Free delivery from : ",
        minimumLivraison: "Minimal amount for delivery : "
      }
    },
    horaires: {
      titre: {
        horaires: "Schedules available",
        livraison: "for delivery",
        retrait: "for in-store pick-up"
      }
    },
    ie: {
      title: "This website doesn't work with the web browser Internet Explorer",
      description: "Please change your web browser to order",
      descriptionModal: "Your Internet Explorer browser is outdated and is not compatible with the operation of our online shops. To place your order, we advise you to use one of the following browsers :"
    },
    bandeau: {
      changerStation: "Change the resort",
      dateLivraison: "Delivery date",
      changer: "Change"
    },
    calendrier: {
      click: {
        order: "Your order",
        for: "for ",
        sentence: "Choose the time to receive your order on this date"
      },
      livraison: {
        phrase: "Your shop delivers on the resort",
        periodeGratuite: {
          intro: " Free delivery when ordering within the period of ",
          mid: " to "
        }
      },
      bouton: {
        txt: "My order for today",
        dernierhoraire: {
          retrait: "Order deadline"
        }
      },
      choixJour: "Choose one delivery day or one pick up day",
      validerBouton: "Confirm",
      recap: {
        commande: {
          first: "Your order",
          retrait: "to pick up in store",
          livraison: "home delivered",
          second: "for",
          third: "at",
          submit: "Submit and start my shopping"
        }
      }
    },
    alert: {
      headerConfirm: 'Leave the store',
      quitPresta: 'Are you sure you want to find a store ? By doing this action, you\'ll loose your cart.',
      accept: 'OK',
      cancel: 'Cancel'
    }
  }
};

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import App from './App.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.use(VueI18n)
Vue.use(BootstrapVue)

const el = document.getElementById('seq_calendrier');
const i18n = new VueI18n({
  fallbackLocale: 'en',
  locale: el.dataset.locale,
  messages,
})
Vue.config.productionTip = false

new Vue({
  i18n,
  render: h => h(App, {
    props: el.dataset
  }),
}).$mount('#seq_calendrier')
